/** Email and password sign-in form for the login page. */
import { useId } from 'react';
import { useT } from '@/i18n/useT';
import LoginPasswordField from '@/features/auth/LoginPasswordField';

const LoginSignInForm = ({
  email,
  password,
  fieldErrors,
  showPassword,
  loading,
  onEmailChange,
  onPasswordChange,
  onEmailBlur,
  onPasswordBlur,
  onToggleShowPassword,
  onSubmit,
  onForgotPassword,
}) => {
  const t = useT();
  const emailErrorId = useId();
  const hasEmailError = Boolean(fieldErrors.email);

  return (
    <form className="login-form" onSubmit={onSubmit} noValidate>
      <div className="login-field">
        <label htmlFor="login-email">{t('login.emailLabel', 'Email')}</label>
        <input
          id="login-email"
          type="email"
          inputMode="email"
          autoComplete="email"
          value={email}
          onChange={onEmailChange}
          onBlur={onEmailBlur}
          aria-invalid={hasEmailError ? 'true' : 'false'}
          aria-describedby={hasEmailError ? emailErrorId : undefined}
        />
        {hasEmailError ? (
          <p id={emailErrorId} className="login-field-error" role="alert">
            {t(fieldErrors.email, fieldErrors.email)}
          </p>
        ) : null}
      </div>
      <LoginPasswordField
        id="login-password"
        label={t('login.passwordLabel', 'Password')}
        value={password}
        onChange={onPasswordChange}
        onBlur={onPasswordBlur}
        autoComplete="current-password"
        errorKey={fieldErrors.password}
        showPassword={showPassword}
        onToggleShow={onToggleShowPassword}
        labelAside={
          <button
            type="button"
            role="link"
            className="login-text-link login-forgot-password-link"
            onClick={onForgotPassword}
          >
            {t('login.forgotPassword', 'Forgot password?')}
          </button>
        }
      />
      <button
        type="submit"
        className="login-submit-button"
        disabled={loading}
        data-testid="login-submit"
      >
        {loading
          ? t('login.submitting', 'Signing in…')
          : t('login.tabSignIn', 'Sign in')}
      </button>
    </form>
  );
};

export default LoginSignInForm;
